export default "__VITE_ASSET__Cf7V_NsF__"